import React from 'react'
import PropTypes from 'prop-types'
import { Conditional } from '@resurs/react-utils'
import { ApplicationType } from '../../../../../models/applicationType'
import { PaymentMethods } from '../../../../../models/payment-methods'
import CardHolders from '../../ApplicationSignPage/UI/CardHolders'
import Owners from '../../ApplicationSignPage/UI/Owners'
import PhysicalIdentification from './PhysicalIdentification'

export const LegalCustomerPhysicalIdentification = ({
  onChangeIdentification,
  onChangeCardHolders,
  onChangeOwners,
  application: {
    application: {
      applicationType,
      businessData: { cardHolders = [], businessOwners = [] } = {},
    },
    customer: {
      identification: {
        type: identificationType,
        reference: identificationReference,
      } = {},
    },
    paymentMethod: { type: paymentMethodType },
  },
  disabled,
}) => (
  <>
    <PhysicalIdentification
      name="applicant"
      onChange={onChangeIdentification}
      type={identificationType}
      reference={identificationReference}
      disabled={disabled}
    />
    <Conditional when={applicationType} is={ApplicationType.NEW_ACCOUNT}>
      <Conditional when={paymentMethodType} is={PaymentMethods.RESURS_NEW_CARD}>
        <div style={{ marginTop: '4rem' }} />
        <CardHolders
          initialValue={cardHolders}
          onChange={onChangeCardHolders}
          disabled={disabled}
        />
      </Conditional>
      <div style={{ marginTop: '4rem' }} />
      <Owners
        initialValue={businessOwners}
        onChange={onChangeOwners}
        disabled={disabled}
      />
    </Conditional>
  </>
)

LegalCustomerPhysicalIdentification.propTypes = {
  onChangeIdentification: PropTypes.func.isRequired,
  onChangeCardHolders: PropTypes.func.isRequired,
  onChangeOwners: PropTypes.func.isRequired,
  application: PropTypes.shape({
    application: PropTypes.object.isRequired,
    paymentMethod: PropTypes.object.isRequired,
  }).isRequired,
  disabled: PropTypes.bool,
}

LegalCustomerPhysicalIdentification.defaultProps = {
  disabled: false,
}
